import { inProduction } from "./env";
import { noop } from "./lang";

export let warn = noop;

inProduction(noop, () => (warn = message => console.warn(message)));
